import React, { useEffect, useMemo, useState } from 'react';

import '../../styles/cena-filmar-2026.css';

const FILMAR_LOGO_BASE64 =
  'data:image/png;base64,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';

const TARGET_DATE = '2026-07-31T19:00:00+02:00';

function getCountdownParts() {
  const target = new Date(TARGET_DATE).getTime();
  const now = new Date().getTime();
  const distance = target - now;

  if (distance <= 0) {
    return { days: '0', hours: '0', minutes: '0', seconds: '0' };
  }

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((distance / (1000 * 60)) % 60);
  const seconds = Math.floor((distance / 1000) % 60);

  return {
    days: String(days),
    hours: String(hours),
    minutes: String(minutes),
    seconds: String(seconds),
  };
}

export default function CenaFilmar2026() {
  const [countdown, setCountdown] = useState(getCountdownParts);

  useEffect(() => {
    document.title = "Cena d'Estate 2026 - Filmar";
  }, []);

  useEffect(() => {
    const upsertMeta = (name, content) => {
      let meta = document.head.querySelector(`meta[name="${name}"]`);
      const hadTag = Boolean(meta);
      const previousContent = meta?.getAttribute('content');

      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }

      meta.setAttribute('content', content);

      return { meta, hadTag, previousContent };
    };

    const robots = upsertMeta('robots', 'noindex, nofollow, noarchive, nosnippet');
    const googlebot = upsertMeta('googlebot', 'noindex, nofollow, noarchive, nosnippet');
    const bingbot = upsertMeta('bingbot', 'noindex, nofollow, noarchive, nosnippet');

    return () => {
      [robots, googlebot, bingbot].forEach(({ meta, hadTag, previousContent }) => {
        if (!hadTag) {
          meta.remove();
          return;
        }

        if (previousContent !== null && previousContent !== undefined) {
          meta.setAttribute('content', previousContent);
        }
      });
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdown(getCountdownParts());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const mapLink = useMemo(
    () =>
      'https://www.google.com/maps/search/?api=1&query=Via%20Sala%2070%2025046%20Cazzago%20San%20Martino%20BS',
    []
  );

  return (
    <div className="cena2026-root">
      <div className="cena2026-background" />

      <main className="cena2026-page">
        <div className="cena2026-logo">
          <img src={FILMAR_LOGO_BASE64} alt="Filmar" />
        </div>

        <p className="cena2026-eyebrow">Filmar - Summer Event</p>

        <div className="cena2026-ornament" aria-hidden="true">
          <div className="cena2026-ornament-line" />
          <div className="cena2026-ornament-dot" />
          <div className="cena2026-ornament-line" />
        </div>

        <h1 className="cena2026-hero-title">
          Cena
          <br />
          <em>d&apos;Estate</em>
        </h1>
        <p className="cena2026-hero-year">- 2026 -</p>

        <div className="cena2026-divider" aria-hidden="true">
          <div className="cena2026-divider-line" />
          <div className="cena2026-divider-dot" />
          <div className="cena2026-divider-line" />
        </div>

        <p className="cena2026-intro">
          Siamo lieti di invitarvi a trascorrere una serata insieme, in un clima conviviale, lontano dal consueto
          contesto lavorativo.
        </p>

        <section className="cena2026-info-grid" aria-label="Informazioni evento">
          <div className="cena2026-info-card">
            <span className="cena2026-info-icon">📍</span>
            <span className="cena2026-info-label">Dove</span>
            <span className="cena2026-info-value">
              Il Priore by Vivilo
              <small>Cazzago San Martino</small>
            </span>
          </div>
          <div className="cena2026-info-card">
            <span className="cena2026-info-icon">📅</span>
            <span className="cena2026-info-label">Quando</span>
            <span className="cena2026-info-value">
              Venerdì
              <br />
              31 luglio 2026
            </span>
          </div>
          <div className="cena2026-info-card">
            <span className="cena2026-info-icon">🕖</span>
            <span className="cena2026-info-label">Orario</span>
            <span className="cena2026-info-value">
              Dalle
              <br />
              ore 19:00
            </span>
          </div>
        </section>

        <div className="cena2026-map-link">
          <span className="cena2026-map-icon">🗺</span>
          <a href={mapLink} target="_blank" rel="noopener noreferrer">
            Indirizzo - Via Sala, 70 - 25046 Cazzago San Martino (BS)
          </a>
        </div>

        <div className="cena2026-divider cena2026-divider-alt" aria-hidden="true">
          <div className="cena2026-divider-line" />
          <div className="cena2026-divider-dot" />
          <div className="cena2026-divider-line" />
        </div>

        <p className="cena2026-section-label">La serata</p>

        <section className="cena2026-programme" aria-label="Programma della serata">
          <div className="cena2026-programme-item">
            <span className="cena2026-programme-time">19:00</span>
            <div className="cena2026-programme-dot" />
            <div>
              <p className="cena2026-programme-desc">Accoglienza e aperitivo</p>
              <p className="cena2026-programme-sub">Un primo momento per incontrarci e iniziare la serata.</p>
            </div>
          </div>

          <div className="cena2026-programme-item">
            <span className="cena2026-programme-time">19:45</span>
            <div className="cena2026-programme-dot" />
            <div>
              <p className="cena2026-programme-desc">Inizio cena</p>
              <p className="cena2026-programme-sub">
                A cura di Vivilo, con dolce finale firmato Pasticceria Roberto.
              </p>
            </div>
          </div>

          <div className="cena2026-programme-item">
            <span className="cena2026-programme-time">23:30</span>
            <div className="cena2026-programme-dot" />
            <div>
              <p className="cena2026-programme-desc">Musica &amp; open bar</p>
              <p className="cena2026-programme-sub">
                Per chi desidera trattenersi e proseguire la serata dopo cena.
              </p>
            </div>
          </div>
        </section>

        <section className="cena2026-teaser">
          <p>
            Una location estiva, una cena conviviale, musica e qualche sorpresa:
            <br />
            un&apos;occasione per rilassarsi e condividere un momento di leggerezza.
          </p>
        </section>

        <div className="cena2026-divider cena2026-divider-alt-2" aria-hidden="true">
          <div className="cena2026-divider-line" />
          <div className="cena2026-divider-dot" />
          <div className="cena2026-divider-line" />
        </div>

        <p className="cena2026-section-label cena2026-section-label-alt">Mancano</p>
        <section className="cena2026-countdown" aria-label="Countdown evento">
          <div className="cena2026-cd-unit">
            <span className="cena2026-cd-num">{countdown.days}</span>
            <span className="cena2026-cd-label">Giorni</span>
          </div>
          <div className="cena2026-cd-unit">
            <span className="cena2026-cd-num">{countdown.hours}</span>
            <span className="cena2026-cd-label">Ore</span>
          </div>
          <div className="cena2026-cd-unit">
            <span className="cena2026-cd-num">{countdown.minutes}</span>
            <span className="cena2026-cd-label">Minuti</span>
          </div>
          <div className="cena2026-cd-unit">
            <span className="cena2026-cd-num">{countdown.seconds}</span>
            <span className="cena2026-cd-label">Secondi</span>
          </div>
        </section>

        <section className="cena2026-rsvp-box">
          <p className="cena2026-rsvp-label">🎟️ Conferma partecipazione</p>
          <h2 className="cena2026-rsvp-title">Vi aspettiamo!</h2>
          <p className="cena2026-rsvp-text">
            Per organizzare al meglio la serata, il menu e l&apos;accoglienza, vi chiediamo di confermare la vostra
            presenza o eventuale assenza compilando il modulo.
            <br />
            Nel form sarà possibile indicare esigenze alimentari o eventuali intolleranze.
          </p>
          <p className="cena2026-rsvp-deadline">
            RSVP entro il <strong>20 luglio 2026</strong>
          </p>
          <a
            className="cena2026-rsvp-btn"
            href="https://filmar.info/cenaziendalefilmar2026"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conferma la tua presenza
          </a>
          <p className="cena2026-rsvp-note">
            Per informazioni: <strong>Michelle Marzoli</strong>
          </p>
        </section>

        <footer className="cena2026-footer">
          <div className="cena2026-footer-logo">
            <img src={FILMAR_LOGO_BASE64} alt="Filmar" />
          </div>
          <p className="cena2026-footer-tagline">Cena d&apos;Estate 2026</p>
        </footer>
      </main>
    </div>
  );
}
